import "./scss/index.scss";
import { Loader } from "@components/atoms";
import { useOrderDetails, useUserDetails } from "@sdk/react";
import * as React from "react";
import Page from "./Page";

var View = function View(_ref) {
  var token = _ref.match.params.token,
      _ref$hideFooter = _ref.hideFooter,
      hideFooter = _ref$hideFooter === void 0 ? false : _ref$hideFooter;

  var _useOrderDetails = useOrderDetails({
    token: token
  }),
      order = _useOrderDetails.data,
      loading = _useOrderDetails.loading;

  var _useUserDetails = useUserDetails(),
      user = _useUserDetails.data;

  var guest = !user;

  if (loading) {
    return React.createElement(Loader, null);
  }

  return React.createElement("div", {
    className: "account-order-details container"
  }, React.createElement(Page, {
    guest: guest,
    order: order,
    hideFooter: hideFooter
  }));
};

View.displayName = "OrderDetailsView";
export default View;